<template>
  <v-chip
    :class="['status-chip', `status-chip--${status}`]"
    small
    label
  >
    <v-icon left size="14" :class="{ 'spin-icon': status === 'andamento' }">
      {{ icon }}
    </v-icon>
    {{ label }}
  </v-chip>
</template>

<script>
const STATUS_MAP = {
  sucesso: { icon: "mdi-check-circle", label: "Sucesso" },
  andamento: { icon: "mdi-autorenew", label: "Em execução" },
  erro: { icon: "mdi-alert-circle", label: "Erro" },
  ocioso: { icon: "mdi-pause-circle-outline", label: "Ocioso" },
  disponivel: { icon: "mdi-power-standby", label: "Disponível" },
  indisponivel: { icon: "mdi-minus-circle-outline", label: "Indisponível" },
  // Agente da Azul
  fila: { icon: "mdi-timer-sand", label: "Na fila" },
  sem_email: { icon: "mdi-email-off-outline", label: "Sem e-mail" },
  aguardando_decisao: {
    icon: "mdi-help-circle-outline",
    label: "Aguardando decisão",
  },
};

export default {
  name: "StatusChip",
  props: {
    status: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    icon() {
      return (STATUS_MAP[this.status] || {}).icon || "mdi-help-circle-outline";
    },
    label() {
      return this.text || (STATUS_MAP[this.status] || {}).label || this.status;
    },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
